// extracted by css-extract-rspack-plugin
export default {"copyButton":"PlaygroundSharedStyles-module__copyButton__uGvTv"};